import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import JournalTable from "components/JournalTable";
import CSVUpload from "components/CSVUpload";
import AutoSync from "components/AutoSync";
import TradeEntryForm from "components/TradeEntryForm";
import { useTheme } from '@mui/material/styles';

function Tables({ userID, userData, selectedAccountID, setSelectedAccountID, tradeAccounts }) { // Added missing props
  const [trades, setTrades] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is signed in with UID:", user.uid);
      } else {
        console.log("User is signed out");
      }
    });
  }, []);

  const handleTradeSubmit = (tradeData) => {
    setTrades(prevTrades => [...prevTrades, tradeData]);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar
        tradeAccounts={tradeAccounts}
        selectedAccountID={selectedAccountID}
        setSelectedAccountID={setSelectedAccountID}
      /> {/* Added props */}
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                style={{ backgroundColor: theme.palette.background.default }}
                borderRadius="lg"
                coloredShadow="warning"
              >
                <MDTypography variant="h6">
                  Journal Entry
                </MDTypography>
              </MDBox>
              <MDBox pt={2} px={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center" height="100%" pb={2}>
<Grid
  container
  spacing={2}
  sx={{
    transition: 'all 0.4s ease-in-out',
    alignItems: 'stretch',
  }}
>
  <Grid
    item
    xs={12}
    md={isFormOpen ? 12 : 6}
    sx={{
      transition: 'all 0.4s ease-in-out',
      flexGrow: 1,
    }}
  >
    <TradeEntryForm 
      userID={userID} 
      onTradeSubmit={handleTradeSubmit} 
      setIsFormOpen={setIsFormOpen}
    />
  </Grid>

  {!isFormOpen && (
    <Grid
      item
      xs={12}
      md={6}
      sx={{
        transition: 'opacity 0.4s ease-in-out',
        opacity: isFormOpen ? 0 : 1,
      }}
    >
      <CSVUpload
        userID={userID}
        tradeAccounts={tradeAccounts}
        selectedAccountID={selectedAccountID}
        setSelectedAccountID={setSelectedAccountID}
      />
    </Grid>
  )}
</Grid>
                </Box>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                style={{ backgroundColor: theme.palette.background.default }}
                borderRadius="lg"
                coloredShadow="warning"
              >
                <MDTypography variant="h6">
                  Journal Table
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={2}>
                <JournalTable userID={userID} userData={userData} selectedAccountID={selectedAccountID} tradeAccounts={tradeAccounts} setSelectedAccountID={setSelectedAccountID}/>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

Tables.propTypes = {
  userID: PropTypes.string.isRequired,
  userData: PropTypes.object,
  selectedAccountID: PropTypes.string.isRequired,
  setSelectedAccountID: PropTypes.func.isRequired, // Added
  tradeAccounts: PropTypes.array.isRequired, // Added
};

export default Tables;